import script from "./Control.vue?vue&type=script&setup=true&lang=js"
export * from "./Control.vue?vue&type=script&setup=true&lang=js"

import "./Control.vue?vue&type=style&index=0&id=e3ce2d78&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3ce2d78"]])

export default __exports__